import React from "react";

const Heading: React.FC<{
  filters: string[],
  name: string,
  text: string
}> = (props) => {
  if (!props.filters.includes(props.name)) return null;
  return <h4 style={{ marginBottom: 2, marginTop: 25, fontSize: 14 }}> {props.text} </h4>;
};

export default Heading;
